interface CurrentUserData {
    name: string;
    userName: string;
}

const extractCurrentUserData = (): CurrentUserData => {
    let name = 'localhost';
    let userName = 'localhost@localhost.com';

    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
        try {
            const item = JSON.parse(sessionStorage.getItem(key) || '{}');
            if (item.hasOwnProperty('name')) {
                name = item.name;
            }
            if (item.hasOwnProperty('username')) {
                userName = item.username;
            }
        } catch (error) {
            console.error(error);
        }
    });

    return { name, userName };
};

export default extractCurrentUserData;
